import { Stack, Typography, useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import { isUndefined } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FINANCES_ROUTE } from '../../constants/routing.constants'
import { useProfileStore } from '../../store/storeProfile'
import { TariffType } from '../../swagger/dto'
import { theme } from '../../theme'
import { CoinLabel } from '../CoinLabel/CoinLabel'
import { useLocalizedTariffName } from '../../utils/getLocalizedTariffName'

export const Balance = ({ isWebView = false }) => {
    const { t } = useTranslation()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const navigate = useNavigate()
    const { balance, userTariff } = useProfileStore((state) => state)
    const localizedTariffName = useLocalizedTariffName()

    if (!isUndefined(balance)) {
        return (
            <Stack direction="row" gap={isMobile ? 4 : 1}>
                <Stack direction="column">
                    <Typography variant={isMobile ? 'h2' : 'caption2'} sx={{ color: '#000' }}>
                        <CoinLabel coin={balance} />
                    </Typography>
                    {userTariff?.tariff?.tariff_type && (
                        <Typography
                            variant="caption2"
                            sx={{ color: '#5E626E', whiteSpace: 'nowrap' }}>
                            {t('balance.level', { tariff: localizedTariffName(userTariff?.tariff.tariff_type) })}
                        </Typography>
                    )}
                </Stack>
                {!isWebView && userTariff?.tariff?.tariff_type === TariffType.FREE && (
                    <Button
                        fullWidth={isMobile}
                        onClick={() => navigate(FINANCES_ROUTE)}
                        color="primary"
                        variant="contained"
                        sx={{
                            padding: '10px 12px',
                            fontSize: '12px',
                            fontWeight: 400,
                            lineHeight: '16px',
                            height: '28px',
                        }}>
                        {t('balance.upgrade')}
                    </Button>
                )}
            </Stack>
        )
    }
}
